import {Row, Col} from 'react-bootstrap';
import "./DataDownloadTile.css";

const DataDownloadTile = (props) => {

  return(
    <div className="data-download-tile">
      <Row>
        <Col
          xs={12}
          sm={12}
          md={3}
          lg={3} >
          <div className="download-icon-border">
            <a href={props.url}><img src="./images/download-icon@2x.png" alt="download-icon"/></a>
          </div>
        </Col>
        <Col
          xs={12}
          sm={12} 
          md={{span: 9, offset: 0}} 
          lg={{span: 9, offset: 0}} >
          <div className="download-tile-headers">
            <span className="download-tile-header1">Download</span>
            <span className="download-tile-header2">
              <span className="new-data-note">NEW</span>
              {" " + props.title}
            </span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col
        xs={12}
        sm={12} 
        md="auto" 
        lg="auto" >
          <div className="download-tile-content">
            <span className="download-tile-content2">If above does not work, download data using the URL:<br/>
              <span>  </span><a href={window.location.href + props.url.replace('./data', '')}>track2</a>
            </span>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default DataDownloadTile;
